import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-160a149a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container pt-5 pb-3" }
const _hoisted_2 = { class: "d-flex justify-content-center align-items-center mb-5" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Floor Plans ")
const _hoisted_5 = {
  key: 0,
  style: {"font-size":"0.8em","opacity":"0.6","font-weight":"400"}
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "monthly-instalment-note" }
const _hoisted_8 = {
  key: 1,
  class: "no-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortfolioLayoutContainer = _resolveComponent("PortfolioLayoutContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        (_ctx.portfolio.units && _ctx.portfolio.units.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(_ctx.portfolio.units.length) + " types)", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.portfolio.units && _ctx.portfolio.units.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portfolio.units, (unit) => {
            return (_openBlock(), _createElementBlock("div", {
              key: unit.name,
              class: "col-12 col-md-6 col-lg-4 col-xl-3"
            }, [
              _createVNode(_component_PortfolioLayoutContainer, {
                unit: unit,
                currency: _ctx.portfolio.currency,
                onOnContactMe: _ctx.onContactMe
              }, null, 8, ["unit", "currency", "onOnContactMe"])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getMonthlyInstalmentConfig(_ctx.portfolio.monthlyInstalmentConfig)), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.portfolio.units || !_ctx.portfolio.units.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No information available. "))
      : _createCommentVNode("", true)
  ]))
}